import http from './http'
import qs from 'qs'
import store from '../store/index'

export const getPost = (url) => {
  return http({
    url: url.indexOf('http') > -1 ? url : `/${url}`,
    method: 'get'
  })
}

export const posts = (url, data) => {
  store.state.loading = true
  const NewData = qs.stringify(data)
  return http({
    url: url,
    method: 'post',
    data: NewData
  })
}
export const postNoLoading = (url, data) => {
  const NewData = qs.stringify(data)
  return http({
    url: url,
    method: 'post',
    data: NewData
  })
}
